import {
  findApplicableDiscount,
  DiscountConfig,
} from './discountCodes';

export interface SessionCostParams {
  duration: 30 | 60;
  originalHourlyRate: number;
  mentorSlug: string;
  discountCode?: string;
}

export interface SessionCostResult {
  finalCost: number;
  originalCost: number;
  discountApplied: DiscountConfig | null;
  discountAmount: number;
}

/**
 * Calculate session cost with discount code verification
 * @param params - Session cost calculation parameters
 * @returns Session cost calculation result with discount information
 */
export const calculateSessionCost = (
  params: SessionCostParams
): SessionCostResult => {
  const { duration, originalHourlyRate, mentorSlug, discountCode } =
    params;

  // Calculate base cost based on duration
  const baseCost =
    duration === 30 ? originalHourlyRate / 2 : originalHourlyRate;

  // Find applicable discount for this mentor and code
  let discount: DiscountConfig | null = null;
  if (discountCode) {
    discount = findApplicableDiscount(mentorSlug, discountCode);
  }

  let finalCost = baseCost;
  let discountAmount = 0;

  if (discount) {
    // Apply discount using the discounted hourly rate
    const discountedHourlyRate = discount.discountedPrice;
    finalCost =
      duration === 30
        ? discountedHourlyRate / 2
        : discountedHourlyRate;
    discountAmount = baseCost - finalCost;
  }

  return {
    finalCost: Math.round(finalCost),
    originalCost: Math.round(baseCost),
    discountApplied: discount,
    discountAmount: Math.round(discountAmount),
  };
};
